<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        color="primary"
        :size="50"
        indeterminate
      />
    </div>

    <div
      class="mt-4"
      v-show="dataLoaded"
    >
      <TitleCard
        :is-show-mode="isShowMode"
        :is-process-mode="isProcessMode"
        :is-edit-mode="isEditMode"
        :disabled="invalid"
        :saveLoading="saveBtnLoading"
        :selected-item="incalculation"
        :is-no-changes="isNoChanges"
        @save="saveIncalculation"
      />

      <v-row
        class="mb-0 mt-2"
        style="margin-right: -14px"
      >
        <v-col
          ref="workList"
          cols="12"
          class="pt-1 pb-2 pr-2 overflow-auto"
        >
          <WorkTitleCard :title="workTypeRusName(workTypeName.Incalculation)" />

          <AuthorsCard
            title="Автор"
            :agreementFileList="agreementFileList"
            class="mt-4"
            :selected-item.sync="incalculation.commonWork.authors"
            :is-show-mode="isShowMode"
            :upload-files="true"
            @updateInvalid="updateAuthorsInvalid"
            @uploadAgreementFile="initUploadAgreementFile"
            @removeAgreementFile="initRemoveAgreementFile"
          />

          <IncalculationCard
            class="mt-4"
            title="Основная информация"
            :linkFileList="linkFileList"
            :selected-item.sync="incalculation"
            :is-show-mode="isShowMode"
            @updateInvalid="updateIncalculationInvalid"
            @uploadLinkFiles="initUploadLinkFiles"
            @removeLinkFile="initRemoveLinkFile"
          />

          <CommentCard
            v-if="Boolean(incalculation.commonWork.comment)"
            class="mt-4"
            :comment="incalculation.commonWork.comment"
          />

          <CreatorCard :creator-name="incalculation.commonWork.creator.fullName" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { incalculationApi } from '@/api'
import TitleCard from '@/components/Works/elements/TitleCard'
import IncalculationCard from '../../components/Works/Incalculation/IncalculationCard'
import { Incalculation } from '../../models'
import AuthorsCard from '../../components/Works/elements/AuthorsCard'
import CommentCard from '@/components/Works/elements/CommentCard.vue'
import { mapActions, mapGetters } from 'vuex'
import { workListHeight } from '@/mixins/workListHeight'
import { dictionaryNames, fileTypeId, workMode, workTypeName } from '@/scripts/consts'
import WorkTitleCard from '@/components/Works/elements/WorkTitleCard.vue'
import CreatorCard from '@/components/Works/elements/CreatorCard.vue'
import { filesForWork } from '@/mixins/filesForWork'

export default {
  name: 'IncalculationPage',

  metaInfo() {
    return {
      title: this && this.workTypeRusName(workTypeName.Incalculation)
    }
  },

  components: {
    CreatorCard,
    WorkTitleCard,
    CommentCard,
    AuthorsCard,
    IncalculationCard,
    TitleCard
  },

  mixins: [workListHeight, filesForWork],

  created() {
    this.isShowMode = this.$route.params.mode === workMode.Show
    this.isProcessMode = this.$route.params.mode === workMode.Process
    this.isEditMode = this.$route.params.mode === workMode.Edit
    this.incalculation = new Incalculation({
      commonWork: {
        isEffContract: true
      }
    })
    this.getData()
  },

  data: () => ({
    incalculation: new Incalculation(),
    selectedItem: null,
    isShowMode: false,
    isEditMode: false,
    isProcessMode: false,
    saveBtnLoading: false,
    dataLoaded: false,
    incalculationInvalid: false,
    authorsInvalid: false,
    isNoChanges: true
  }),

  computed: {
    workTypeName() {
      return workTypeName
    },
    ...mapGetters('workTypes', ['workTypeByName', 'workTypeRusName']),

    invalid() {
      return this.authorsInvalid || this.incalculationInvalid
    }
  },

  methods: {
    ...mapActions('dictionaries', ['getDictionaries']),
    ...mapActions('workTypes', ['getWorkTypes']),

    async getData() {
      if (!this.isShowMode)
        await this.getDictionaries([dictionaryNames.Year, dictionaryNames.Department, dictionaryNames.InculcationLevel])
      await this.getWorkTypes()
      await this.getIncalculation()
      this.dataLoaded = true
      this.isNoChanges = true
    },

    async getIncalculation() {
      try {
        if (this.$route.params?.id !== '0') {
          const data = await incalculationApi.get(this.$route.params?.id)
          await this.getFileList(data.commonWork?.id)
          this.incalculation = new Incalculation(data)
        }
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось получить данные по работе')
      }
    },

    async saveIncalculation(isThrowError = false) {
      try {
        this.saveBtnLoading = true

        if (!this.incalculation.id)
          this.incalculation.commonWork.workType = this.workTypeByName(workTypeName.Incalculation)

        const body = this.incalculation.getForAPI()

        const data = this.incalculation.id ? await incalculationApi.update(body) : await incalculationApi.create(body)

        await this.removeFileFromAPI()

        const linkFileListForSave = this.linkFileList.filter(file => !file.id)
        const agreementFileListForSave = this.agreementFileList.filter(file => !file.id)

        if (linkFileListForSave.length) await this.saveFile(data?.commonWork?.id, linkFileListForSave, fileTypeId.link)
        if (agreementFileListForSave.length)
          await this.saveFile(data?.commonWork?.id, agreementFileListForSave, fileTypeId.agreement)

        if (!this.incalculation.id) await this.$router.replace('/works/incalculation/edit/' + data.id)

        await this.getFileList(data.commonWork?.id)
        this.incalculation = new Incalculation(data)
        this.$toast.info('Работа успешно сохранена')
        queueMicrotask(() => (this.isNoChanges = true))
      } catch (e) {
        console.log(e)
        if (e.message === 'Ошибка удаления файлов') this.getFileList(this.incalculation.commonWork?.id)
        else this.showErrorMessage(e, 'Ошибка сохранения работы')
        if (isThrowError) throw new Error('Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    initUploadLinkFiles(files) {
      this.uploadLinkFiles(files)
      this.isNoChanges = false
    },

    initRemoveLinkFile(index) {
      this.removeLinkFile(index)
      this.isNoChanges = false
    },

    initUploadAgreementFile(file) {
      this.uploadAgreementFile(file)
      this.isNoChanges = false
    },

    initRemoveAgreementFile(index) {
      this.removeAgreementFile(index)
      this.isNoChanges = false
    },

    async updateAuthorsInvalid(val) {
      this.authorsInvalid = val
      this.isNoChanges = false
    },

    async updateIncalculationInvalid(val) {
      this.incalculationInvalid = val
      this.isNoChanges = false
    }
  },

  watch: {
    dataLoaded() {
      this.setWorkListHeight()
    }
  },

  provide: function () {
    return {
      saveWork: this.saveIncalculation
    }
  }
}
</script>

<style scoped></style>
